import { createAsyncThunk } from "@reduxjs/toolkit";
import { ActionTypes } from "../constants/action-types";
import { apiCall } from "../../apis/api";

export const createRoomDetails = createAsyncThunk(
  ActionTypes.CREATE_ROOM_DETAILS,
  async (body: any, { rejectWithValue }) => {
    try {
      const res = await apiCall("room-details/build-room", "post", body);
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const fetchInventoryFromVideo = createAsyncThunk(
  ActionTypes.GET_INVENTORY_FROM_VIDEO,
  async (body: any, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        "room-details/create-room-details",
        "post",
        body
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const updateRoomDetails = createAsyncThunk(
  ActionTypes.UPDATE_ROOM_DETAILS,
  async (body: any, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        `room-details/update-room-details`,
        "patch",
        body
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getInventoryVolume = createAsyncThunk(
  ActionTypes.CALCULATE_INVENTORY_VOLUME,
  async (moveRequestId: string, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        `room-details/calculate-total-cubic-feet/${moveRequestId}`,
        "get"
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const fetchInventoryFromImage = createAsyncThunk(
  ActionTypes.GET_INVENTORY_FROM_IMAGE,
  async (
    formData: FormData, 
    { rejectWithValue }
  ) => {
    try {
      const res = await apiCall(
        "inventory/upload-inventory",
        "post",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } } 
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const fetchInventoryByPhone = createAsyncThunk(
  ActionTypes.GET_INVENTORY_BY_PHONE,
  async (body: { phone: string }, { rejectWithValue }) => {
    try {
      const res = await apiCall("inventory/fetch-inventory", "post", body);
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getFullInventory = createAsyncThunk(
  ActionTypes.GET_FULL_INVENTORY,
  async (body: { phone: string }, { rejectWithValue }) => {
    try {
      const res = await apiCall("inventory/get-inventory", "post", body);
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const uploadAndDetectInventory = createAsyncThunk(
  ActionTypes.UPLOAD_AND_DETECT_INVENTORY,
  async (formData: FormData, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        "room-details/upload-and-detect",
        "post",
        formData
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);      


export const sendInventoryText = createAsyncThunk(
  ActionTypes.SEND_INVENTORY_TEXT,
  async (body: { phone: string }, { rejectWithValue }) => {
    try {
      const res = await apiCall("inventory/send-text", "post", body);
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const saveInventory = createAsyncThunk(
  ActionTypes.SEND_FILTERED_INVENTORY, 
  async (body: { sessionId: string; inventory: any }, { rejectWithValue }) => {
    try {
      const res = await apiCall("inventory/save-inventory", "post", body); 
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);